import produce from 'immer';

import {
  types,
  GetOrdersAsyncRequest,
  GetOrdersAsyncPending,
  GetOrdersAsyncError,
  GetOrdersAsyncSuccess,
  GetOrderDetailsAsyncRequest,
  GetOrderDetailsAsyncPending,
  GetOrderDetailsAsyncError,
  GetOrderDetailsAsyncSuccess,
  WillCallActionTypes,
  WillCallState,
  SetSelectedLookupOption,
  OrderLineItem
} from './types';

export const actions = {
  resetWillCall: (): WillCallActionTypes => ({ type: types.RESET_WILL_CALL }),
  resetOrderDetails: (): WillCallActionTypes => ({ type: types.RESET_ORDER_DETAILS }),
  getOrders: (payload: GetOrdersAsyncRequest['payload']): WillCallActionTypes => ({
    type: types.GET_WILL_CALL_ORDERS.REQUEST,
    payload
  }),
  getOrder: (payload: GetOrderDetailsAsyncRequest['payload']): WillCallActionTypes => ({
    type: types.GET_ORDER_DETAILS.REQUEST,
    payload
  }),
  setSelectedLookupOption: (payload: SetSelectedLookupOption['payload']): WillCallActionTypes => ({
    type: types.SET_SELECTED_LOOKUP_OPTION,
    payload
  })
};

export const initialState: WillCallState = {
  ordersList: [],
  orderDetails: [],
  customer: {},
  loading: false,
  error: undefined,
  selectedLookupOption: undefined
};

export const reducer = (state: WillCallState = initialState, action: WillCallActionTypes): WillCallState => {
  // eslint-disable-next-line consistent-return
  return produce(state, draft => {
    switch (action.type) {
      case types.GET_ORDER_DETAILS.SUCCESS:
        draft.customer = (action as GetOrderDetailsAsyncSuccess).payload.customer;
        const orderDatails = (action as GetOrderDetailsAsyncSuccess).payload.orders;
        const orderDetailList: OrderLineItem[] = [];
        orderDatails.forEach(order => {
          order.lineItems.forEach(lineItem => {
            orderDetailList.push(lineItem);
          });
        });
        draft.orderDetails = orderDetailList;
        break;
      case types.GET_ORDER_DETAILS.PENDING:
      case types.GET_WILL_CALL_ORDERS.PENDING:
        draft.loading = (action as GetOrderDetailsAsyncPending | GetOrdersAsyncPending).payload;
        break;
      case types.GET_ORDER_DETAILS.ERROR:
      case types.GET_WILL_CALL_ORDERS.ERROR:
        draft.error = (action as GetOrderDetailsAsyncError | GetOrdersAsyncError).payload;
        break;
      case types.GET_WILL_CALL_ORDERS.SUCCESS:
        draft.customer = (action as GetOrdersAsyncSuccess).payload.customer;
        draft.ordersList = (action as GetOrdersAsyncSuccess).payload.orderSummaries;
        break;
      case types.RESET_WILL_CALL:
        draft.ordersList = initialState.ordersList;
        draft.orderDetails = initialState.orderDetails;
        draft.customer = initialState.customer;
        draft.loading = initialState.loading;
        draft.error = initialState.error;
        break;
      case types.RESET_ORDER_DETAILS:
        draft.orderDetails = initialState.orderDetails;
        draft.loading = initialState.loading;
        draft.error = initialState.error;
        break;
      case types.SET_SELECTED_LOOKUP_OPTION:
        draft.selectedLookupOption = (action as SetSelectedLookupOption).payload;
        break;
      default:
    }
  });
};
